import React, { useState, useEffect } from 'react';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import Config from '../../config/env';
import API from '../../utils/apiCalling';
import Loader from '../../utils/loader';
import { useParams } from 'react-router-dom/cjs/react-router-dom';

const LmvExcelReport = ({ data }) => {
  const [dashboardData, setDashboardData] = useState([]);
  const [allQuestions, setAllQuestions] = useState([]);
  const [loader, setLoader] = useState(false);
  const [surveyId, setSurveyId] = useState(null);
  const checkarray = ['Enter your Email','Enter Bank','Enter your City','Type Of User']
  const id = useParams();

  let api = new API();

  useEffect(() => {
    console.log("data",data)
    setDashboardData(data);

 
  }, []);

  


  // Helper function to check if the question is in the checkarray
  const isQuestionInCheckArray = (question) => {
    return checkarray.includes(question);
  };
  const handleDownload = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');

    worksheet.getColumn(1).width = 10;
    worksheet.getColumn(2).width = 20;
    worksheet.getColumn(3).width = 45;
    worksheet.getColumn(4).width = 10;
    worksheet.getColumn(5).width = 10;
    worksheet.getColumn(6).width = 10;
    worksheet.getColumn(7).width = 10;
    worksheet.getColumn(8).width = 10;
    worksheet.getColumn(9).width = 10;
    worksheet.getColumn(10).width = 10;
    worksheet.getColumn(11).width = 10;
    worksheet.getColumn(12).width = 10;
    worksheet.getColumn(13).width = 10;
    worksheet.getColumn(14).width = 10;
    worksheet.getColumn(15).width = 10;

    // Merge cells for headers
    worksheet.mergeCells('A1:AJ1');
    worksheet.mergeCells('A2:AJ2');
    worksheet.mergeCells('A21:AJ21');
    worksheet.mergeCells('A3:A3');
    worksheet.mergeCells('A4:A4');
    worksheet.mergeCells('A5:A5');
    worksheet.mergeCells('A6:A6');
    worksheet.mergeCells('A7:A7');
    worksheet.mergeCells('A8:A8');
    worksheet.mergeCells('A9:A9');
    worksheet.mergeCells('A10:A10');
    worksheet.mergeCells('A11:A11');
    worksheet.mergeCells('A12:A12');
    worksheet.mergeCells('A13:A13');
    worksheet.mergeCells('A14:A14');
    worksheet.mergeCells('A15:A15');
    worksheet.mergeCells('A16:A16');
    worksheet.mergeCells('A17:A17');
    worksheet.mergeCells('A18:A18');
    worksheet.mergeCells('A19:A19');
    worksheet.mergeCells('A22:A22');
    worksheet.mergeCells('A23:A23');
    worksheet.mergeCells('A24:A24');
    worksheet.mergeCells('A25:A25');
    worksheet.mergeCells('A26:A26');
    worksheet.mergeCells('A27:A27');
    worksheet.mergeCells('A28:A28');
    worksheet.mergeCells('A29:A29');
    worksheet.mergeCells('A31:C31');
 

    worksheet.mergeCells('B3:B3');
    worksheet.mergeCells('B4:B4');
    worksheet.mergeCells('B5:B5');
    worksheet.mergeCells('B6:B6');
    worksheet.mergeCells('B7:B7');
    worksheet.mergeCells('B8:B8');
    worksheet.mergeCells('B9:B9');
    worksheet.mergeCells('B10:B10');
    worksheet.mergeCells('B11:B11');
    worksheet.mergeCells('B12:B12');
    worksheet.mergeCells('B13:B13');
    worksheet.mergeCells('B14:B14');
    worksheet.mergeCells('B15:B15');
    worksheet.mergeCells('B16:B16');
    worksheet.mergeCells('B17:B17');
    worksheet.mergeCells('B18:B18');
    worksheet.mergeCells('B19:B19');
    worksheet.mergeCells('B22:B22');
    worksheet.mergeCells('B23:B23');
    worksheet.mergeCells('B24:B24');
    worksheet.mergeCells('B25:B25');
    worksheet.mergeCells('B26:B26');
    worksheet.mergeCells('B27:B27');
    worksheet.mergeCells('B28:B28');
    worksheet.mergeCells('B29:B29');


    worksheet.mergeCells('C3:C3');
    worksheet.mergeCells('C4:C4');
    worksheet.mergeCells('C5:C5');
    worksheet.mergeCells('C6:C6');
    worksheet.mergeCells('C7:C7');
    worksheet.mergeCells('C8:C8');
    worksheet.mergeCells('C9:C9');
    worksheet.mergeCells('C10:C10');
    worksheet.mergeCells('C11:C11');
    worksheet.mergeCells('C12:C12');
    worksheet.mergeCells('C13:C13');
    worksheet.mergeCells('C14:C14');
    worksheet.mergeCells('C15:C15');
    worksheet.mergeCells('C16:C16');
    worksheet.mergeCells('C17:C17');
    worksheet.mergeCells('C18:C18');
    worksheet.mergeCells('C19:C19');
    worksheet.mergeCells('C22:C22');
    worksheet.mergeCells('C23:C23');
    worksheet.mergeCells('C24:C24');
    worksheet.mergeCells('C25:C25');
    worksheet.mergeCells('C26:C26');
    worksheet.mergeCells('C27:C27');
    worksheet.mergeCells('C28:C28');
    worksheet.mergeCells('C29:C29');

    // Merge cells for new headers
    worksheet.mergeCells('D3:D3');
    worksheet.mergeCells('D4:D4');
    worksheet.mergeCells('D5:D5');
    worksheet.mergeCells('D6:D6');
    worksheet.mergeCells('D7:D7');
    worksheet.mergeCells('D8:D8');
    worksheet.mergeCells('D9:D9');
    worksheet.mergeCells('D10:D10');
    worksheet.mergeCells('D11:D11');
    worksheet.mergeCells('D12:D12');
    worksheet.mergeCells('D13:D13');
    worksheet.mergeCells('D14:D14');
    worksheet.mergeCells('D15:D15');
    worksheet.mergeCells('D16:D16');
    worksheet.mergeCells('D17:D17');
    worksheet.mergeCells('D18:D18');
    worksheet.mergeCells('D19:D19');


    // Define styles
    const headerStyle = {
      font: { bold: true, color: { argb: '00000000' } },
      fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'dededd' } },
      alignment: { horizontal: 'center', vertical: 'middle' },
      border: {
        top: { style: 'thin', color: { argb: 'FF000000' } },
        left: { style: 'thin', color: { argb: 'FF000000' } },
        bottom: { style: 'thin', color: { argb: 'FF000000' } },
        right: { style: 'thin', color: { argb: 'FF000000' } }
      }
    };
    const PhysicalBenchmarkingstyle = {
      font: { bold: true, color: { argb: 'FFFFFF' } },
      fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '8080FF' } },
      alignment: { horizontal: 'center', vertical: 'middle' },
      border: {
        top: { style: 'thin', color: { argb: 'FF000000' } },
        left: { style: 'thin', color: { argb: 'FF000000' } },
        bottom: { style: 'thin', color: { argb: 'FF000000' } },
        right: { style: 'thin', color: { argb: 'FF000000' } }
      }
    };
    const UsedVehiclestyle = {
      font: { bold: true, color: { argb: '00000000' } },
      fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFF00' } },
      alignment: { horizontal: 'center', vertical: 'middle' },
      border: {
        top: { style: 'thin', color: { argb: 'FF000000' } },
        left: { style: 'thin', color: { argb: 'FF000000' } },
        bottom: { style: 'thin', color: { argb: 'FF000000' } },
        right: { style: 'thin', color: { argb: 'FF000000' } }
      }
    };

    const plannedstyle = {
      font: { bold: false, color: { argb: '00000000' } },
      fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'bdd3f9' } },
      alignment: { horizontal: 'center', vertical: 'middle' },
      border: {
        top: { style: 'thin', color: { argb: 'FF000000' } },
        left: { style: 'thin', color: { argb: 'FF000000' } },
        bottom: { style: 'thin', color: { argb: 'FF000000' } },
        right: { style: 'thin', color: { argb: 'FF000000' } }
      }
    };
    const cellStyle = {
      font: { bold: false, color: { argb: '00000000' } },
      fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } },
      alignment: { horizontal: 'center', vertical: 'middle' },
      border: {
        top: { style: 'thin', color: { argb: 'FF000000' } },
        left: { style: 'thin', color: { argb: 'FF000000' } },
        bottom: { style: 'thin', color: { argb: 'FF000000' } },
        right: { style: 'thin', color: { argb: 'FF000000' } }
      }
    };
    const plannedcellstyle = {
      font: { bold: false, color: { argb: '00000000' } },
      fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'dfebf7' } },
      alignment: { horizontal: 'center', vertical: 'middle' },
      border: {
        top: { style: 'thin', color: { argb: 'FF000000' } },
        left: { style: 'thin', color: { argb: 'FF000000' } },
        bottom: { style: 'thin', color: { argb: 'FF000000' } },
        right: { style: 'thin', color: { argb: 'FF000000' } }
      }
    };
    const achievedstyle = {
      font: { color: { argb: '00000000' }, size: 12, },
      fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '92c67c' } },
      alignment: { horizontal: 'center', vertical: 'middle' },
      border: {
        top: { style: 'thin', color: { argb: 'FF000000' } },
        left: { style: 'thin', color: { argb: 'FF000000' } },
        bottom: { style: 'thin', color: { argb: 'FF000000' } },
        right: { style: 'thin', color: { argb: 'FF000000' } }
      }
    };
    const achievedcellstyle = {
      font: { bold: false, color: { argb: '00000000' } },
      fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ddf9d6' } },
      alignment: { horizontal: 'center', vertical: 'middle' },
      border: {
        top: { style: 'thin', color: { argb: 'FF000000' } },
        left: { style: 'thin', color: { argb: 'FF000000' } },
        bottom: { style: 'thin', color: { argb: 'FF000000' } },
        right: { style: 'thin', color: { argb: 'FF000000' } }
      }
    };
    const pendingtyle = {
      font: { color: { argb: '00000000' } },
      fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'fe9c9c' } },
      alignment: { horizontal: 'center', vertical: 'middle' },
      border: {
        top: { style: 'thin', color: { argb: 'FF000000' } },
        left: { style: 'thin', color: { argb: 'FF000000' } },
        bottom: { style: 'thin', color: { argb: 'FF000000' } },
        right: { style: 'thin', color: { argb: 'FF000000' } }
      }
    };
    const pendingcellstyle = {
      font: { bold: false, color: { argb: '00000000' } },
      fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ffe6e6' } },
      alignment: { horizontal: 'center', vertical: 'middle' },
      border: {
        top: { style: 'thin', color: { argb: 'FF000000' } },
        left: { style: 'thin', color: { argb: 'FF000000' } },
        bottom: { style: 'thin', color: { argb: 'FF000000' } },
        right: { style: 'thin', color: { argb: 'FF000000' } }
      }
    };


    // Define cell values and styles for column A
    const cellsToStyleA = [
      { cell: 'A1', value: 'Physical Benchmarking' },
      { cell: 'A2', value: 'Used Vehicle' },
      { cell: 'A21', value: 'New Vehicle' },
      { cell: 'A31', value: 'Grand Total' },
      { cell: 'A3', value: 'S.No.' },
      { cell: 'A4', value: '1' },
      { cell: 'A5', value: '2' },
      { cell: 'A6', value: '3' },
      { cell: 'A7', value: '4' },
      { cell: 'A8', value: '5' },
      { cell: 'A9', value: '6' },
      { cell: 'A10', value: '7' },
      { cell: 'A11', value: '8' },
      { cell: 'A12', value: '9' },
      { cell: 'A13', value: '10' },
      { cell: 'A14', value: '11' },
      { cell: 'A15', value: '12' },
      { cell: 'A16', value: '13' },
      { cell: 'A17', value: '14' },
      { cell: 'A18', value: '15' },
      { cell: 'A19', value: ' ' },
      { cell: 'A22', value: 'S.No.' },
      { cell: 'A23', value: '1' },
      { cell: 'A24', value: '2' },
      { cell: 'A25', value: '3' },
      { cell: 'A26', value: '4' },
      { cell: 'A27', value: '5' },
      { cell: 'A28', value: '6' },
      { cell: 'A29', value: ' ' },
     

    ];

    cellsToStyleA.forEach(({ cell, value }) => {
      const excelCell = worksheet.getCell(cell);
      excelCell.value = value;
      if (value == "S.No." || value == "Grand Total") {
        excelCell.font = headerStyle.font;
        excelCell.fill = headerStyle.fill;
        excelCell.alignment = headerStyle.alignment;
        excelCell.border = headerStyle.border;
      }
      else if (value == "Physical Benchmarking") {
        excelCell.font = PhysicalBenchmarkingstyle.font;
        excelCell.fill = PhysicalBenchmarkingstyle.fill;
        excelCell.alignment = PhysicalBenchmarkingstyle.alignment;
        excelCell.border = PhysicalBenchmarkingstyle.border;
      }
      else if (value == "Used Vehicle" || value == "New Vehicle") {
        excelCell.font = UsedVehiclestyle.font;
        excelCell.fill = UsedVehiclestyle.fill;
        excelCell.alignment = UsedVehiclestyle.alignment;
        excelCell.border = UsedVehiclestyle.border;
      }
      else {
        // excelCell.fill = headerStyle.fill;
        excelCell.alignment = headerStyle.alignment;
        excelCell.border = headerStyle.border;
        excelCell.fill = cellStyle.fill;
      }
    });

    // Define cell values and styles for column B
    const cellsToStyleB = [
        { cell: 'B3', value: 'Organisation' },
        { cell: 'B4', value: 'Mahindra Finance' },
        { cell: 'B5', value: 'Tata Motors Finance' },
        { cell: 'B6', value: 'Cholamandalam' },
        { cell: 'B7', value: 'HDB' },
        { cell: 'B8', value: 'IDFC First Bank' },
        { cell: 'B9', value: 'IndusInd Bank' },
        { cell: 'B10', value: 'AU Small Finance Bank' },
        { cell: 'B11', value: 'Equitas Bank' },
        { cell: 'B12', value: 'Tata OK' },
        { cell: 'B13', value: 'Shriram Automall' },
        { cell: 'B14', value: 'Multi Brand Outlet' },
        { cell: 'B15', value: 'Mahindra' },
        { cell: 'B16', value: 'TATA' },
        { cell: 'B17', value: 'Maruti' },
        { cell: 'B18', value: 'Ashok Leyland' },
        { cell: 'B19', value: 'Total' },
        { cell: 'B22', value: 'Organisation' },
        { cell: 'B23', value: 'Mahindra' },
        { cell: 'B24', value: 'TATA' },
        { cell: 'B25', value: 'Maruti' },
        { cell: 'B26', value: 'Ashok Leyland' },
        { cell: 'B27', value: 'IDFC First Bank' },
        { cell: 'B28', value: 'IndusInd Bank' },
        { cell: 'B29', value: 'Total' },
    ];

    cellsToStyleB.forEach(({ cell, value }) => {


      const excelCell = worksheet.getCell(cell);
      excelCell.value = value;
      if (value == "Organisation" || value == "Total") {
        excelCell.font = headerStyle.font;
        excelCell.fill = headerStyle.fill;
        excelCell.alignment = headerStyle.alignment;
        excelCell.border = headerStyle.border;
      }
      else {
        // excelCell.fill = headerStyle.fill;
        excelCell.alignment = headerStyle.alignment;
        excelCell.border = headerStyle.border;
        excelCell.fill = cellStyle.fill;
      }
    });

    // Define cell values and styles for column C
    const cellsToStyleC = [
        { cell: 'C3', value: 'Place to be visited' },
        { cell: 'C4', value: 'Mahindra Outlet' },
        { cell: 'C5', value: 'TATA Outlet' },
        { cell: 'C6', value: 'Dealership store of the listed vehicle' },
        { cell: 'C7', value: 'Dealership store of the listed vehicle' },
        { cell: 'C8', value: 'Respective bank visit' },
        { cell: 'C9', value: 'Respective bank visit' },
        { cell: 'C10', value: 'Respective bank visit' },
        { cell: 'C11', value: 'Respective bank visit' },
        { cell: 'C12', value: 'Dealership' },
        { cell: 'C13', value: 'Dealership' },
        { cell: 'C14', value: 'Mahindra m trust, Tata OK' },
        { cell: 'C15', value: 'Mahindra Outlet' },
        { cell: 'C16', value: 'TATA Outlet' },
        { cell: 'C17', value: 'Dealership store of the listed vehicle' },
        { cell: 'C18', value: 'Dealership store of the listed vehicle' },
        { cell: 'C19', value: '' },
        { cell: 'C22', value: 'Place to be visited' },
        { cell: 'C23', value: 'Mahindra Outlet' },
        { cell: 'C24', value: 'TATA Outlet' },
        { cell: 'C25', value: 'Dealership store of the listed vehicle' },
        { cell: 'C26', value: 'Dealership store of the listed vehicle' },
        { cell: 'C27', value: 'Respective bank visit' },
        { cell: 'C28', value: 'Respective bank visit' },
        { cell: 'C29', value: '' },

    ];

    let data = ['Organized', 'Unorganized', 'Below 6 lakh', '6-10 lakh', 'More than 10 lakh', 'Retired (60+)', 'NCCS A1,A2,A3(50%)', 'Minimum 50%']

    cellsToStyleC.forEach(({ cell, value }) => {
      const excelCell = worksheet.getCell(cell);
      excelCell.value = value;
      if (value == "Place to be visited") {
        excelCell.font = headerStyle.font;
        excelCell.fill = headerStyle.fill;
        excelCell.alignment = headerStyle.alignment;
        excelCell.border = headerStyle.border;
      } else if (value == "Total") {
        excelCell.font = headerStyle.font;
        excelCell.fill = headerStyle.fill;
        excelCell.alignment = headerStyle.alignment;
        excelCell.border = headerStyle.border;
      }
      else {
        // excelCell.fill = headerStyle.fill;
        excelCell.alignment = headerStyle.alignment;
        excelCell.border = headerStyle.border;
        excelCell.fill = cellStyle.fill;
      }


    });

      // Define cell values and styles for column D
      const cellsToStyleD = [
        { cell: 'D3', value: 'Final loan enquiry will be done for' },
        { cell: 'D4', value: 'Mahindra Finance' },
        { cell: 'D5', value: 'Tata Motors Finance' },
        { cell: 'D6', value: 'Cholamandalam' },
        { cell: 'D7', value: 'HDB' },
        { cell: 'D8', value: 'IDFC First Bank' },
        { cell: 'D9', value: 'IndusInd Bank' },
        { cell: 'D10', value: 'AU Small Finance Bank' },
        { cell: 'D11', value: 'Equitas Bank' },
        { cell: 'D12', value: 'Primary pitched brand' },
        { cell: 'D13', value: 'Primary pitched brand' },
        { cell: 'D14', value: 'Most pitched brand' },
        { cell: 'D15', value: 'Primary pitched brand' },
        { cell: 'D16', value: 'Primary pitched brand' },
        { cell: 'D17', value: 'Primary pitched brand' },
        { cell: 'D18', value: 'Primary pitched brand' },
        { cell: 'D19', value: '' },
    ];


    // Define cell values and styles for new headers
    const cellsToStyleNew = [
      { cell: 'D3', value: 'Total' },
      { cell: 'E3', value: 'Achieved' },
      { cell: 'F3', value: 'Pending' },
      { cell: 'G3', value: 'Delhi NCR' },
      { cell: 'H3', value: 'Achieved' },
      { cell: 'I3', value: 'Pending' },
      { cell: 'J3', value: 'Mumbai' },
      { cell: 'K3', value: 'Achieved' },
      { cell: 'L3', value: 'Pending' },
      { cell: 'M3', value: 'Chennai' },
      { cell: 'N3', value: 'Achieved' },
      { cell: 'O3', value: 'Pending' },
      { cell: 'P3', value: 'Kolkata' },
      { cell: 'Q3', value: 'Achieved' },
      { cell: 'R3', value: 'Pending' },
      { cell: 'S3', value: 'Hyderabad' },
      { cell: 'T3', value: 'Achieved' },
      { cell: 'U3', value: 'Pending' },
      { cell: 'V3', value: 'Lucknow' },
      { cell: 'W3', value: 'Achieved' },
      { cell: 'X3', value: 'Pending' },
      { cell: 'Y3', value: 'Ahmedabad' },
      { cell: 'Z3', value: 'Achieved' },
      { cell: 'AA3', value: 'Pending' },
      { cell: 'AB3', value: 'Nasik' },
      { cell: 'AC3', value: 'Achieved' },
      { cell: 'AD3', value: 'Pending' },
      { cell: 'AE3', value: 'Cochin' },
      { cell: 'AF3', value: 'Achieved' },
      { cell: 'AG3', value: 'Pending' },
      { cell: 'AH3', value: 'Ranchi' },
      { cell: 'AI3', value: 'Achieved' },
      { cell: 'AJ3', value: 'Pending' },
      { cell: 'D22', value: 'Total' },
      { cell: 'E22', value: 'Achieved' },
      { cell: 'F22', value: 'Pending' },
      { cell: 'G22', value: 'Delhi NCR' },
      { cell: 'H22', value: 'Achieved' },
      { cell: 'I22', value: 'Pending' },
      { cell: 'J22', value: 'Mumbai' },
      { cell: 'K22', value: 'Achieved' },
      { cell: 'L22', value: 'Pending' },
      { cell: 'M22', value: 'Chennai' },
      { cell: 'N22', value: 'Achieved' },
      { cell: 'O22', value: 'Pending' },
      { cell: 'P22', value: 'Kolkata' },
      { cell: 'Q22', value: 'Achieved' },
      { cell: 'R22', value: 'Pending' },
      { cell: 'S22', value: 'Hyderabad' },
      { cell: 'T22', value: 'Achieved' },
      { cell: 'U22', value: 'Pending' },
      { cell: 'V22', value: 'Lucknow' },
      { cell: 'W22', value: 'Achieved' },
      { cell: 'X22', value: 'Pending' },
      { cell: 'Y22', value: 'Ahmedabad' },
      { cell: 'Z22', value: 'Achieved' },
      { cell: 'AA22', value: 'Pending' },
      { cell: 'AB22', value: 'Nasik' },
      { cell: 'AC22', value: 'Achieved' },
      { cell: 'AD22', value: 'Pending' },
      { cell: 'AE22', value: 'Cochin' },
      { cell: 'AF22', value: 'Achieved' },
      { cell: 'AG22', value: 'Pending' },
      { cell: 'AH22', value: 'Ranchi' },
      { cell: 'AI22', value: 'Achieved' },
      { cell: 'AJ22', value: 'Pending' },
      
    
    ];
    let data2 = ['Total', 'Delhi NCR', 'Mumbai', 'Chennai', 'Kolkata', 'Hyderabad',  'Ahmedabad', 'Nasik', 'Cochin', 'Mysuru', 'Lucknow', 'Ranchi', ]
    cellsToStyleNew.forEach(({ cell, value }) => {
      const excelCell = worksheet.getCell(cell);
      excelCell.value = value;
      if (data2.includes(value)) {
        excelCell.font = headerStyle.font;
        excelCell.fill = plannedstyle.fill;
        excelCell.alignment = headerStyle.alignment;
        excelCell.border = headerStyle.border;
      } else if (value == 'Planned') {
        excelCell.font = headerStyle.font;
        excelCell.fill = plannedstyle.fill;
        excelCell.alignment = headerStyle.alignment;
        excelCell.border = headerStyle.border;
      } else if (value == 'Achieved') {
        excelCell.font = headerStyle.font;
        excelCell.fill = achievedstyle.fill;
        excelCell.alignment = headerStyle.alignment;
        excelCell.border = headerStyle.border;
      } else if (value == 'Pending') {
        excelCell.font = headerStyle.font;
        excelCell.fill = pendingtyle.fill;
        excelCell.alignment = headerStyle.alignment;
        excelCell.border = headerStyle.border;
      }
      else {
        // excelCell.fill = headerStyle.fill;
        excelCell.alignment = headerStyle.alignment;
        excelCell.border = headerStyle.border;
        excelCell.fill = headerStyle.fill;
        excelCell.font = headerStyle.font;
      }

    });
    let columnDValues = []
    // Define the values to fill in column E
  
      columnDValues = [2, 2, 2, 2, 10, 9, 9, 8, 8, 9, 9, 7, 6, 7, 6, 96]
    
   
    // Fill values in column D only if the corresponding cell in column C is not empty
    let valueIndex = 0;
    for (let rowIndex = 4; rowIndex <= 19; rowIndex++) {
      const cellC = worksheet.getCell(`B${rowIndex}`);
      if (cellC.value) {
        const cellE = worksheet.getCell(`D${rowIndex}`);
        cellE.value = columnDValues[valueIndex++];
        if (rowIndex == 19) {
          cellE.font = headerStyle.font
          cellE.fill = plannedstyle.fill;
        }
        else {
          cellE.font = cellStyle.font;
          cellE.fill = plannedcellstyle.fill;

        }
        cellE.alignment = cellStyle.alignment;
        cellE.border = cellStyle.border;
      }

    }

    let columnDValuesnew = []
    // Define the values to fill in column E
  
      columnDValuesnew = [20,20,19,17,10,10,96]
    
   
    // Fill values in column D only if the corresponding cell in column C is not empty
    let valueIndexD = 0;
    for (let rowIndex = 23; rowIndex <= 29; rowIndex++) {
      const cellC = worksheet.getCell(`B${rowIndex}`);
      if (cellC.value) {
        const cellE = worksheet.getCell(`D${rowIndex}`);
        cellE.value = columnDValuesnew[valueIndexD++];
        if (rowIndex == 29) {
          cellE.font = headerStyle.font
          cellE.fill = plannedstyle.fill;
        }
        else {
          cellE.font = cellStyle.font;
          cellE.fill = plannedcellstyle.fill;

        }
        cellE.alignment = cellStyle.alignment;
        cellE.border = cellStyle.border;
      }

    }


    
    // Define the values to fill in column G


    let columnGValues = []
    // Define the values to fill in column H

      columnGValues = [1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,11]
      
    // Fill values in column G only if the corresponding cell in column C is not empty
    let valueIndexG = 0;
    for (let rowIndex = 4; rowIndex <= 19; rowIndex++) {
      const cellC = worksheet.getCell(`B${rowIndex}`);
      if (cellC.value) {
        const cellD = worksheet.getCell(`G${rowIndex}`);
        cellD.value = columnGValues[valueIndexG++];
        if (rowIndex == 19) {
          cellD.font = headerStyle.font
          cellD.fill = plannedstyle.fill;
        }
        else {
          cellD.font = cellStyle.font;
          cellD.fill = plannedcellstyle.fill;
        }
        cellD.alignment = cellStyle.alignment;
        cellD.border = cellStyle.border;
      }
    }

    let columnGValuesnew = []
    // Define the values to fill in column E
  
    columnGValuesnew = [2, 2, 2, 2, 1,1,10]
    
   
    // Fill values in column D only if the corresponding cell in column C is not empty
    let valueIndexnewG = 0;
    for (let rowIndex = 23; rowIndex <= 29; rowIndex++) {
      const cellC = worksheet.getCell(`B${rowIndex}`);
      if (cellC.value) {
        const cellE = worksheet.getCell(`G${rowIndex}`);
        cellE.value = columnGValuesnew[valueIndexnewG++];
        if (rowIndex == 29) {
          cellE.font = headerStyle.font
          cellE.fill = plannedstyle.fill;
        }
        else {
          cellE.font = cellStyle.font;
          cellE.fill = plannedcellstyle.fill;

        }
        cellE.alignment = cellStyle.alignment;
        cellE.border = cellStyle.border;
      }

    }


    let columnJValues = []
   
      columnJValues = [1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,11]

    
    // Fill values in column G only if the corresponding cell in column C is not empty
    let valueIndexJ = 0;
    for (let rowIndex = 4; rowIndex <= 19; rowIndex++) {
      const cellC = worksheet.getCell(`B${rowIndex}`);
      if (cellC.value) {
        const cellD = worksheet.getCell(`J${rowIndex}`);
        cellD.value = columnJValues[valueIndexJ++];
        if (rowIndex == 19) {
          cellD.font = headerStyle.font
          cellD.fill = plannedstyle.fill;
        }
        else {
          cellD.font = cellStyle.font;

          cellD.fill = plannedcellstyle.fill;
        }
        cellD.alignment = cellStyle.alignment;
        cellD.border = cellStyle.border;
      }
    }

    let columnJValuesnew = []
    // Define the values to fill in column E
  
    columnJValuesnew = [2, 2, 2, 2, 1,1,10]
    
   
    // Fill values in column D only if the corresponding cell in column C is not empty
    let valueIndexnewJ = 0;
    for (let rowIndex = 23; rowIndex <= 29; rowIndex++) {
      const cellC = worksheet.getCell(`B${rowIndex}`);
      if (cellC.value) {
        const cellE = worksheet.getCell(`J${rowIndex}`);
        cellE.value = columnJValuesnew[valueIndexnewJ++];
        if (rowIndex == 29) {
          cellE.font = headerStyle.font
          cellE.fill = plannedstyle.fill;
        }
        else {
          cellE.font = cellStyle.font;
          cellE.fill = plannedcellstyle.fill;

        }
        cellE.alignment = cellStyle.alignment;
        cellE.border = cellStyle.border;
      }

    }
    // Define the values to fill in column N

    let columnMValues = []
      columnMValues = [0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,11]
    
   

    // Fill values in column M only if the corresponding cell in column C is not empty
    let valueIndexM = 0;
    for (let rowIndex = 4; rowIndex <= 19; rowIndex++) {
      const cellC = worksheet.getCell(`B${rowIndex}`);
      if (cellC.value) {
        const cellD = worksheet.getCell(`M${rowIndex}`);
        cellD.value = columnMValues[valueIndexM++];
        if (rowIndex == 19) {
          cellD.font = headerStyle.font
          cellD.fill = plannedstyle.fill;
        }
        else {
          cellD.font = cellStyle.font;

          cellD.fill = plannedcellstyle.fill;
        }
        cellD.alignment = cellStyle.alignment;
        cellD.border = cellStyle.border;
      }
    }

    let columnMValuesnew = []
    // Define the values to fill in column E
  
    columnMValuesnew = [2, 2, 2, 2, 1,1,10]
    
   
    // Fill values in column D only if the corresponding cell in column C is not empty
    let valueIndexnewM = 0;
    for (let rowIndex = 23; rowIndex <= 29; rowIndex++) {
      const cellC = worksheet.getCell(`B${rowIndex}`);
      if (cellC.value) {
        const cellE = worksheet.getCell(`M${rowIndex}`);
        cellE.value = columnMValuesnew[valueIndexnewM++];
        if (rowIndex == 29) {
          cellE.font = headerStyle.font
          cellE.fill = plannedstyle.fill;
        }
        else {
          cellE.font = cellStyle.font;
          cellE.fill = plannedcellstyle.fill;

        }
        cellE.alignment = cellStyle.alignment;
        cellE.border = cellStyle.border;
      }

    }
    // Define the values to fill in column Q
    let columnPValues = []
      columnPValues = [0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,11]
    
  

    // Fill values in column P only if the corresponding cell in column C is not empty
    let valueIndexP = 0;
    for (let rowIndex = 4; rowIndex <= 19; rowIndex++) {
      const cellC = worksheet.getCell(`B${rowIndex}`);
      if (cellC.value) {
        const cellD = worksheet.getCell(`P${rowIndex}`);
        cellD.value = columnPValues[valueIndexP++];
        if (rowIndex == 19) {
          cellD.font = headerStyle.font
          cellD.fill = plannedstyle.fill;
        }
        else {
          cellD.font = cellStyle.font;

          cellD.fill = plannedcellstyle.fill;
        }
        cellD.alignment = cellStyle.alignment;
        cellD.border = cellStyle.border;
      }
    }

    // Define the values to fill in column T
    let columnPValuesnew = []
    // Define the values to fill in column E
  
    columnPValuesnew = [2, 2, 2, 2, 1,1,10]
    
   
    // Fill values in column D only if the corresponding cell in column C is not empty
    let valueIndexnewP = 0;
    for (let rowIndex = 23; rowIndex <= 29; rowIndex++) {
      const cellC = worksheet.getCell(`B${rowIndex}`);
      if (cellC.value) {
        const cellE = worksheet.getCell(`P${rowIndex}`);
        cellE.value = columnPValuesnew[valueIndexnewP++];
        if (rowIndex == 29) {
          cellE.font = headerStyle.font
          cellE.fill = plannedstyle.fill;
        }
        else {
          cellE.font = cellStyle.font;
          cellE.fill = plannedcellstyle.fill;

        }
        cellE.alignment = cellStyle.alignment;
        cellE.border = cellStyle.border;
      }

    }

    let columnSValues = []
      columnSValues = [0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,11]
    
    

    // Fill values in column S only if the corresponding cell in column C is not empty
    let valueIndexS = 0;
    for (let rowIndex = 4; rowIndex <= 19; rowIndex++) {
      const cellC = worksheet.getCell(`B${rowIndex}`);
      if (cellC.value) {
        const cellD = worksheet.getCell(`S${rowIndex}`);
        cellD.value = columnSValues[valueIndexS++];
        if (rowIndex == 19) {
          cellD.font = headerStyle.font
          cellD.fill = plannedstyle.fill;
        }
        else {
          cellD.font = cellStyle.font;

          cellD.fill = plannedcellstyle.fill;
        }
        cellD.alignment = cellStyle.alignment;
        cellD.border = cellStyle.border;
      }
    }

    // Define the values to fill in column W
    let columnSValuesnew = []
    // Define the values to fill in column E
  
    columnSValuesnew = [2, 2, 2, 2, 1,1,10]
    
   
    // Fill values in column D only if the corresponding cell in column C is not empty
    let valueIndexnewS = 0;
    for (let rowIndex = 23; rowIndex <= 29; rowIndex++) {
      const cellC = worksheet.getCell(`B${rowIndex}`);
      if (cellC.value) {
        const cellE = worksheet.getCell(`S${rowIndex}`);
        cellE.value = columnSValuesnew[valueIndexnewS++];
        if (rowIndex == 29) {
          cellE.font = headerStyle.font
          cellE.fill = plannedstyle.fill;
        }
        else {
          cellE.font = cellStyle.font;
          cellE.fill = plannedcellstyle.fill;

        }
        cellE.alignment = cellStyle.alignment;
        cellE.border = cellStyle.border;
      }

    }

    let columnValues = []

      columnValues = [0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,11]

    
    

    let valueIndexV = 0;
    for (let rowIndex = 4; rowIndex <= 19; rowIndex++) {
      const cellC = worksheet.getCell(`B${rowIndex}`);
      if (cellC.value) {
        const cellD = worksheet.getCell(`V${rowIndex}`);
        cellD.value = columnValues[valueIndexV++];
        if (rowIndex == 19) {
          cellD.font = headerStyle.font
          cellD.fill = plannedstyle.fill;
        }
        else {
          cellD.font = cellStyle.font;

          cellD.fill = plannedcellstyle.fill;
        }
        cellD.alignment = cellStyle.alignment;
        cellD.border = cellStyle.border;
      }
    }

    // Define the values to fill in column Z
    let columnVValuesnew = []
    // Define the values to fill in column E
  
    columnVValuesnew = [2, 2, 2, 2, 1,1,10]
    
   
    // Fill values in column D only if the corresponding cell in column C is not empty
    let valueIndexnewV = 0;
    for (let rowIndex = 23; rowIndex <= 29; rowIndex++) {
      const cellC = worksheet.getCell(`B${rowIndex}`);
      if (cellC.value) {
        const cellE = worksheet.getCell(`V${rowIndex}`);
        cellE.value = columnVValuesnew[valueIndexnewV++];
        if (rowIndex == 29) {
          cellE.font = headerStyle.font
          cellE.fill = plannedstyle.fill;
        }
        else {
          cellE.font = cellStyle.font;
          cellE.fill = plannedcellstyle.fill;

        }
        cellE.alignment = cellStyle.alignment;
        cellE.border = cellStyle.border;
      }

    }

    let columnYValues = []
      columnYValues = [0,0,0,0,1,1,1,1,1,1,1,1,1,1,1,11]
    
   

    // Fill values in column Y only if the corresponding cell in column C is not empty
    let valueIndexY = 0;
    for (let rowIndex = 4; rowIndex <= 19; rowIndex++) {
      const cellC = worksheet.getCell(`B${rowIndex}`);
      if (cellC.value) {
        const cellD = worksheet.getCell(`Y${rowIndex}`);
        cellD.value = columnYValues[valueIndexY++];
        if (rowIndex == 19) {
          cellD.font = headerStyle.font
          cellD.fill = plannedstyle.fill;
        }
        else {
          cellD.font = cellStyle.font;

          cellD.fill = plannedcellstyle.fill;
        }
        cellD.alignment = cellStyle.alignment;
        cellD.border = cellStyle.border;
      }
    }

    let columnYValuesnew = []
    // Define the values to fill in column E
  
    columnYValuesnew = [2, 2, 2, 2, 1,1,10]
    
   
    // Fill values in column D only if the corresponding cell in column C is not empty
    let valueIndexnewY = 0;
    for (let rowIndex = 23; rowIndex <= 29; rowIndex++) {
      const cellC = worksheet.getCell(`B${rowIndex}`);
      if (cellC.value) {
        const cellE = worksheet.getCell(`Y${rowIndex}`);
        cellE.value = columnYValuesnew[valueIndexnewY++];
        if (rowIndex == 29) {
          cellE.font = headerStyle.font
          cellE.fill = plannedstyle.fill;
        }
        else {
          cellE.font = cellStyle.font;
          cellE.fill = plannedcellstyle.fill;

        }
        cellE.alignment = cellStyle.alignment;
        cellE.border = cellStyle.border;
      }

    }
    // Define the values to fill in column AC



    let columnABValues = []
      columnABValues = [0,0,0,0,1,1,1,0,0,1,1,1,0,1,0,7]

    
   

    // Fill values in column AB only if the corresponding cell in column C is not empty
    let valueIndexAB = 0;
    for (let rowIndex = 4; rowIndex <= 19; rowIndex++) {
      const cellC = worksheet.getCell(`B${rowIndex}`);
      if (cellC.value) {
        const cellD = worksheet.getCell(`AB${rowIndex}`);
        cellD.value = columnABValues[valueIndexAB++];
        if (rowIndex == 19) {
          cellD.font = headerStyle.font
          cellD.fill = plannedstyle.fill;
        }
        else {
          cellD.font = cellStyle.font;

          cellD.fill = plannedcellstyle.fill;
        }
        cellD.alignment = cellStyle.alignment;
        cellD.border = cellStyle.border;
      }
    }

    let columnABValuesnew = []
    // Define the values to fill in column E
  
    columnABValuesnew = [2, 2, 2, 1,1,1,9]
    
   
    // Fill values in column D only if the corresponding cell in column C is not empty
    let valueIndexnewAB = 0;
    for (let rowIndex = 23; rowIndex <= 29; rowIndex++) {
      const cellC = worksheet.getCell(`B${rowIndex}`);
      if (cellC.value) {
        const cellE = worksheet.getCell(`AB${rowIndex}`);
        cellE.value = columnABValuesnew[valueIndexnewAB++];
        if (rowIndex == 29) {
          cellE.font = headerStyle.font
          cellE.fill = plannedstyle.fill;
        }
        else {
          cellE.font = cellStyle.font;
          cellE.fill = plannedcellstyle.fill;

        }
        cellE.alignment = cellStyle.alignment;
        cellE.border = cellStyle.border;
      }

    }
    // Define the values to fill in column AF


    let columnAEValues = []
      columnAEValues = [0,0,0,0,1,1,0,1,1,0,0,0,1,0,1,6]
    
   

    // Fill values in column AE only if the corresponding cell in column C is not empty
    let valueIndexAE = 0;
    for (let rowIndex = 4; rowIndex <= 19; rowIndex++) {
      const cellC = worksheet.getCell(`B${rowIndex}`);
      if (cellC.value) {
        const cellD = worksheet.getCell(`AE${rowIndex}`);
        cellD.value = columnAEValues[valueIndexAE++];
        if (rowIndex == 19) {
          cellD.font = headerStyle.font
          cellD.fill = plannedstyle.fill;
        }
        else {
          cellD.font = cellStyle.font;

          cellD.fill = plannedcellstyle.fill;
        }
        cellD.alignment = cellStyle.alignment;
        cellD.border = cellStyle.border;
      }
    }



    let columnAEValuesnew = []
    // Define the values to fill in column E
  
    columnAEValuesnew = [2, 2, 1, 1, 1,1,8]
    
   
    // Fill values in column D only if the corresponding cell in column C is not empty
    let valueIndexnewAE = 0;
    for (let rowIndex = 23; rowIndex <= 29; rowIndex++) {
      const cellC = worksheet.getCell(`B${rowIndex}`);
      if (cellC.value) {
        const cellE = worksheet.getCell(`AE${rowIndex}`);
        cellE.value = columnAEValuesnew[valueIndexnewAE++];
        if (rowIndex == 29) {
          cellE.font = headerStyle.font
          cellE.fill = plannedstyle.fill;
        }
        else {
          cellE.font = cellStyle.font;
          cellE.fill = plannedcellstyle.fill;

        }
        cellE.alignment = cellStyle.alignment;
        cellE.border = cellStyle.border;
      }

    }
    // Define the values to fill in column AI

    let columnAHValues = []
      columnAHValues = [0,0,0,0,1,0,1,0,0,1,1,1,0,1,0,6]
    
    

    // Fill values in column AH only if the corresponding cell in column C is not empty
    let valueIndexAH = 0;
    for (let rowIndex = 4; rowIndex <= 19; rowIndex++) {
      const cellC = worksheet.getCell(`B${rowIndex}`);
      if (cellC.value) {
        const cellD = worksheet.getCell(`AH${rowIndex}`);
        cellD.value = columnAHValues[valueIndexAH++];
        if (rowIndex == 19) {
          cellD.font = headerStyle.font
          cellD.fill = plannedstyle.fill;
        }
        else {
          cellD.font = cellStyle.font;

          cellD.fill = plannedcellstyle.fill;
        }
        cellD.alignment = cellStyle.alignment;
        cellD.border = cellStyle.border;
      }
    }
    let columnAHValuesnew = []
    // Define the values to fill in column E
  
    columnAHValuesnew = [2, 2, 2, 1, 1,1,9]
    
   
    // Fill values in column D only if the corresponding cell in column C is not empty
    let valueIndexnewAH = 0;
    for (let rowIndex = 23; rowIndex <= 29; rowIndex++) {
      const cellC = worksheet.getCell(`B${rowIndex}`);
      if (cellC.value) {
        const cellE = worksheet.getCell(`AH${rowIndex}`);
        cellE.value = columnAHValuesnew[valueIndexnewAH++];
        if (rowIndex == 29) {
          cellE.font = headerStyle.font
          cellE.fill = plannedstyle.fill;
        }
        else {
          cellE.font = cellStyle.font;
          cellE.fill = plannedcellstyle.fill;

        }
        cellE.alignment = cellStyle.alignment;
        cellE.border = cellStyle.border;
      }

    }

    
    // ---------Delhi-------------       
    // Define criteria for "Achieved" columns
    const criteriaMap = {
      // 3: ['Delhi', 'Organized sector - you or your firm/ company is registered', 'Self-Employed Professional/Businessman/Freelancer'],
      4: ['Delhi NCR', 'Mahindra Finance','Used Vehicle'],
      5: ['Delhi NCR', 'Tata Motors Finance','Used Vehicle'],
      6: ['Delhi NCR', 'Cholamandalam','Used Vehicle'],
      7: ['Delhi NCR', 'HDB','Used Vehicle'],
      8: ['Delhi NCR', 'IDFC First Bank','Used Vehicle'],
      9: ['Delhi NCR', 'IndusInd Bank','Used Vehicle'],
      10: ['Delhi NCR', 'AU Small Finance Bank','Used Vehicle'],
      11: ['Delhi NCR', 'Equitas Bank','Used Vehicle'],
      12: ['Delhi NCR', 'Tata OK','Used Vehicle'],
      13: ['Delhi NCR', 'Shriram Automall','Used Vehicle'],
      14: ['Delhi NCR',  'Multi Brand Outlet','Used Vehicle'],
      15: ['Delhi NCR', 'Mahindra','Used Vehicle'],
      16: ['Delhi NCR', 'TATA','Used Vehicle'],
      17: ['Delhi NCR',  'Maruti','Used Vehicle'],
      18: ['Delhi NCR',  'Ashok Leyland','Used Vehicle'],
      23: ['Delhi NCR',  'Mahindra','New Vehicle'],
      24: ['Delhi NCR',  'TATA','New Vehicle'],
      25: ['Delhi NCR',  'Maruti','New Vehicle'],
      26: ['Delhi NCR',  'Ashok Leyland','New Vehicle'],
      27: ['Delhi NCR',  'IDFC First Bank','New Vehicle'],
      28: ['Delhi NCR',  'IndusInd Bank','New Vehicle'],
     
     };

    // Helper function to check if a criterion is met
    const isCriterionMet = (answer, criterion) => {
      if (Array.isArray(criterion)) {
        return criterion.some(crit => Array.isArray(answer) ? answer.includes(crit) : answer === crit);
      } else {
       if (Array.isArray(answer)) {
          return answer.includes(criterion) || 
                 (criterion === 'Rs. 10-15 lakh per annum' && answer.includes('More than Rs. 15 lakh per annum')) ||
                 (criterion === 'Other' && answer.some(ans => ans.includes('Other:')));
        } else {
          return answer === criterion || 
                 (criterion === 'Rs. 10-15 lakh per annum' && answer === 'More than Rs. 15 lakh per annum') ||
                 (criterion === 'Other' && answer?.includes('Other:'));
        }
      }
    };

    // Count matches and fill values in "Achieved" column
    const countMatches = (criteria) => {

      return dashboardData.filter(response =>
        criteria.every(criterion =>
          Array.isArray(criterion) ? criterion.some(subCriterion =>
            response.questions.some(q => isQuestionInCheckArray(q.question) && isCriterionMet(q.answer, subCriterion))
          ) :
            response.questions.some(q => isQuestionInCheckArray(q.question) && isCriterionMet(q.answer, criterion))
        )
      ).length;
    };

    Object.keys(criteriaMap).forEach(rowIndex => {
      const criteria = criteriaMap[rowIndex];
      const count = countMatches(criteria);
      const cellH = worksheet.getCell(`H${rowIndex}`);
      cellH.value = count;
      cellH.font = cellStyle.font;
      cellH.fill = achievedcellstyle.fill;
      cellH.alignment = cellStyle.alignment;
      cellH.border = cellStyle.border;
    });

    // --------jaipur-------
    // Define criteria for "Achieved" columns
 
    // ------------------------Chandigarh---------------
    // Define criteria for "Achieved" columns
    const criteriaMapMumbai = {
      4: ['Mumbai', 'Mahindra Finance','Used Vehicle'],
      5: ['Mumbai', 'Tata Motors Finance','Used Vehicle'],
      6: ['Mumbai', 'Cholamandalam','Used Vehicle'],
      7: ['Mumbai', 'HDB','Used Vehicle'],
      8: ['Mumbai', 'IDFC First Bank','Used Vehicle'],
      9: ['Mumbai', 'IndusInd Bank','Used Vehicle'],
      10: ['Mumbai', 'AU Small Finance Bank','Used Vehicle'],
      11: ['Mumbai', 'Equitas Bank','Used Vehicle'],
      12: ['Mumbai', 'Tata OK','Used Vehicle'],
      13: ['Mumbai', 'Shriram Automall','Used Vehicle'],
      14: ['Mumbai',  'Multi Brand Outlet','Used Vehicle'],
      15: ['Mumbai', 'Mahindra','Used Vehicle'],
      16: ['Mumbai', 'TATA','Used Vehicle'],
      17: ['Mumbai',  'Maruti','Used Vehicle'],
      18: ['Mumbai',  'Ashok Leyland','Used Vehicle'],
      23: ['Mumbai',  'Mahindra','New Vehicle'],
      24: ['Mumbai',  'TATA','New Vehicle'],
      25: ['Mumbai',  'Maruti','New Vehicle'],
      26: ['Mumbai',  'Ashok Leyland','New Vehicle'],
      27: ['Mumbai',  'IDFC First Bank','New Vehicle'],
      28: ['Mumbai',  'IndusInd Bank','New Vehicle'],
  };

    // Helper function to check if a criterion is met
    const isCriterionMetMumbai = (answer, criterion) => {
      if (Array.isArray(criterion)) {
        return criterion.some(crit => Array.isArray(answer) ? answer.includes(crit) : answer === crit);
      } else {
       if (Array.isArray(answer)) {
          return answer.includes(criterion) || 
                 (criterion === 'Rs. 10-15 lakh per annum' && answer.includes('More than Rs. 15 lakh per annum')) ||
                 (criterion === 'Other' && answer.some(ans => ans.includes('Other:')));
        } else {
          return answer === criterion || 
                 (criterion === 'Rs. 10-15 lakh per annum' && answer === 'More than Rs. 15 lakh per annum') ||
                 (criterion === 'Other' && answer?.includes('Other:'));
        }
      }
    };

    // Count matches and fill values in "Achieved" column
    const countMatchesMumbai = (criteria) => {
      return dashboardData.filter(response =>
        criteria.every(criterion =>
          Array.isArray(criterion) ? criterion.some(subCriterion =>
            response.questions.some(q => isQuestionInCheckArray(q.question) && isCriterionMetMumbai(q.answer, subCriterion))
          ) :
            response.questions.some(q => isQuestionInCheckArray(q.question) && isCriterionMetMumbai(q.answer, criterion))
        )
      ).length;

    };

    Object.keys(criteriaMapMumbai).forEach(rowIndex => {
      const criteria = criteriaMapMumbai[rowIndex];
      const count = countMatchesMumbai(criteria);
      const cellH = worksheet.getCell(`K${rowIndex}`);
      cellH.value = count;
      cellH.font = cellStyle.font;
      cellH.fill = achievedcellstyle.fill;
      cellH.alignment = cellStyle.alignment;
      cellH.border = cellStyle.border;
    });

   
    const criteriaMapChennai = {
      4: ['Chennai', 'Mahindra Finance','Used Vehicle'],
      5: ['Chennai', 'Tata Motors Finance','Used Vehicle'],
      6: ['Chennai', 'Cholamandalam','Used Vehicle'],
      7: ['Chennai', 'HDB','Used Vehicle'],
      8: ['Chennai', 'IDFC First Bank','Used Vehicle'],
      9: ['Chennai', 'IndusInd Bank','Used Vehicle'],
      10: ['Chennai', 'AU Small Finance Bank','Used Vehicle'],
      11: ['Chennai', 'Equitas Bank','Used Vehicle'],
      12: ['Chennai', 'Tata OK','Used Vehicle'],
      13: ['Chennai', 'Shriram Automall','Used Vehicle'],
      14: ['Chennai',  'Multi Brand Outlet','Used Vehicle'],
      15: ['Chennai', 'Mahindra','Used Vehicle'],
      16: ['Chennai', 'TATA','Used Vehicle'],
      17: ['Chennai',  'Maruti','Used Vehicle'],
      18: ['Chennai',  'Ashok Leyland','Used Vehicle'],
      23: ['Chennai',  'Mahindra','New Vehicle'],
      24: ['Chennai',  'TATA','New Vehicle'],
      25: ['Chennai',  'Maruti','New Vehicle'],
      26: ['Chennai',  'Ashok Leyland','New Vehicle'],
      27: ['Chennai',  'IDFC First Bank','New Vehicle'],
      28: ['Chennai',  'IndusInd Bank','New Vehicle'],
       };

    // Helper function to check if a criterion is met
    const isCriterionMetChennai = (answer, criterion) => {
      if (Array.isArray(criterion)) {
        return criterion.some(crit => Array.isArray(answer) ? answer.includes(crit) : answer === crit);
      } else {
       if (Array.isArray(answer)) {
          return answer.includes(criterion) || 
                 (criterion === 'Rs. 10-15 lakh per annum' && answer.includes('More than Rs. 15 lakh per annum')) ||
                 (criterion === 'Other' && answer.some(ans => ans.includes('Other:')));
        } else {
          return answer === criterion || 
                 (criterion === 'Rs. 10-15 lakh per annum' && answer === 'More than Rs. 15 lakh per annum') ||
                 (criterion === 'Other' && answer?.includes('Other:'));
        }
      }
    };

    // Count matches and fill values in "Achieved" column
    const countMatchesChennai = (criteria) => {

      return dashboardData.filter(response =>
        criteria.every(criterion =>
          Array.isArray(criterion) ? criterion.some(subCriterion =>
            response.questions.some(q => isQuestionInCheckArray(q.question) && isCriterionMetChennai(q.answer, subCriterion))
          ) :
            response.questions.some(q => isQuestionInCheckArray(q.question) && isCriterionMetChennai(q.answer, criterion))
        )
      ).length;
    };

    Object.keys(criteriaMapChennai).forEach(rowIndex => {
      const criteria = criteriaMapChennai[rowIndex];
      const count = countMatchesChennai(criteria);
      const cellH = worksheet.getCell(`N${rowIndex}`);
      cellH.value = count;
      cellH.font = cellStyle.font;
      cellH.fill = achievedcellstyle.fill;
      cellH.alignment = cellStyle.alignment;
      cellH.border = cellStyle.border;
    });
    // ------------------------Patna---------------
    // Define criteria for "Achieved" columns
    const criteriaMapKolkata = {
      4: ['Kolkata', 'Mahindra Finance','Used Vehicle'],
      5: ['Kolkata', 'Tata Motors Finance','Used Vehicle'],
      6: ['Kolkata', 'Cholamandalam','Used Vehicle'],
      7: ['Kolkata', 'HDB','Used Vehicle'],
      8: ['Kolkata', 'IDFC First Bank','Used Vehicle'],
      9: ['Kolkata', 'IndusInd Bank','Used Vehicle'],
      10: ['Kolkata', 'AU Small Finance Bank','Used Vehicle'],
      11: ['Kolkata', 'Equitas Bank','Used Vehicle'],
      12: ['Kolkata', 'Tata OK','Used Vehicle'],
      13: ['Kolkata', 'Shriram Automall','Used Vehicle'],
      14: ['Kolkata',  'Multi Brand Outlet','Used Vehicle'],
      15: ['Kolkata', 'Mahindra','Used Vehicle'],
      16: ['Kolkata', 'TATA','Used Vehicle'],
      17: ['Kolkata',  'Maruti','Used Vehicle'],
      18: ['Kolkata',  'Ashok Leyland','Used Vehicle'],
      23: ['Kolkata',  'Mahindra','New Vehicle'],
      24: ['Kolkata',  'TATA','New Vehicle'],
      25: ['Kolkata',  'Maruti','New Vehicle'],
      26: ['Kolkata',  'Ashok Leyland','New Vehicle'],
      27: ['Kolkata',  'IDFC First Bank','New Vehicle'],
      28: ['Kolkata',  'IndusInd Bank','New Vehicle'],  };

    // Helper function to check if a criterion is met
    const isCriterionMetKolkata = (answer, criterion) => {
      if (Array.isArray(criterion)) {
        return criterion.some(crit => Array.isArray(answer) ? answer.includes(crit) : answer === crit);
      } else {
       if (Array.isArray(answer)) {
          return answer.includes(criterion) || 
                 (criterion === 'Rs. 10-15 lakh per annum' && answer.includes('More than Rs. 15 lakh per annum')) ||
                 (criterion === 'Other' && answer.some(ans => ans.includes('Other:')));
        } else {
          return answer === criterion || 
                 (criterion === 'Rs. 10-15 lakh per annum' && answer === 'More than Rs. 15 lakh per annum') ||
                 (criterion === 'Other' && answer?.includes('Other:'));
        }
      }
    };

    // Count matches and fill values in "Achieved" column
    const countMatchesKolkata = (criteria) => {

      return dashboardData.filter(response =>
        criteria.every(criterion =>
          Array.isArray(criterion) ? criterion.some(subCriterion =>
            response.questions.some(q => isQuestionInCheckArray(q.question) && isCriterionMetKolkata(q.answer, subCriterion))
          ) :
            response.questions.some(q => isQuestionInCheckArray(q.question) && isCriterionMetKolkata(q.answer, criterion))
        )
      ).length;
    };

    Object.keys(criteriaMapKolkata).forEach(rowIndex => {
      const criteria = criteriaMapKolkata[rowIndex];
      const count = countMatchesKolkata(criteria);
      const cellH = worksheet.getCell(`Q${rowIndex}`);
      cellH.value = count;
      cellH.font = cellStyle.font;
      cellH.fill = achievedcellstyle.fill;
      cellH.alignment = cellStyle.alignment;
      cellH.border = cellStyle.border;
    });


    const criteriaMapHyderabad = {
      4: ['Hyderabad', 'Mahindra Finance','Used Vehicle'],
      5: ['Hyderabad', 'Tata Motors Finance','Used Vehicle'],
      6: ['Hyderabad', 'Cholamandalam','Used Vehicle'],
      7: ['Hyderabad', 'HDB','Used Vehicle'],
      8: ['Hyderabad', 'IDFC First Bank','Used Vehicle'],
      9: ['Hyderabad', 'IndusInd Bank','Used Vehicle'],
      10: ['Hyderabad', 'AU Small Finance Bank','Used Vehicle'],
      11: ['Hyderabad', 'Equitas Bank','Used Vehicle'],
      12: ['Hyderabad', 'Tata OK','Used Vehicle'],
      13: ['Hyderabad', 'Shriram Automall','Used Vehicle'],
      14: ['Hyderabad',  'Multi Brand Outlet','Used Vehicle'],
      15: ['Hyderabad', 'Mahindra','Used Vehicle'],
      16: ['Hyderabad', 'TATA','Used Vehicle'],
      17: ['Hyderabad',  'Maruti','Used Vehicle'],
      18: ['Hyderabad',  'Ashok Leyland','Used Vehicle'],
      23: ['Hyderabad',  'Mahindra','New Vehicle'],
      24: ['Hyderabad',  'TATA','New Vehicle'],
      25: ['Hyderabad',  'Maruti','New Vehicle'],
      26: ['Hyderabad',  'Ashok Leyland','New Vehicle'],
      27: ['Hyderabad',  'IDFC First Bank','New Vehicle'],
      28: ['Hyderabad',  'IndusInd Bank','New Vehicle'],
   };

    // Helper function to check if a criterion is met
    const isCriterionMetHyderabad = (answer, criterion) => {
      if (Array.isArray(criterion)) {
        return criterion.some(crit => Array.isArray(answer) ? answer.includes(crit) : answer === crit);
      } else {
       if (Array.isArray(answer)) {
          return answer.includes(criterion) || 
                 (criterion === 'Rs. 10-15 lakh per annum' && answer.includes('More than Rs. 15 lakh per annum')) ||
                 (criterion === 'Other' && answer.some(ans => ans.includes('Other:')));
        } else {
          return answer === criterion || 
                 (criterion === 'Rs. 10-15 lakh per annum' && answer === 'More than Rs. 15 lakh per annum') ||
                 (criterion === 'Other' && answer?.includes('Other:'));
        }
      }
    };

    // Count matches and fill values in "Achieved" column
    const countMatchesHyderabad = (criteria) => {

      return dashboardData.filter(response =>
        criteria.every(criterion =>
          Array.isArray(criterion) ? criterion.some(subCriterion =>
            response.questions.some(q => isQuestionInCheckArray(q.question) && isCriterionMetHyderabad(q.answer, subCriterion))
          ) :
            response.questions.some(q => isQuestionInCheckArray(q.question) && isCriterionMetHyderabad(q.answer, criterion))
        )
      ).length;
    };

    Object.keys(criteriaMapHyderabad).forEach(rowIndex => {
      const criteria = criteriaMapHyderabad[rowIndex];

      const count = countMatchesHyderabad(criteria);

      const cellH = worksheet.getCell(`T${rowIndex}`);
      cellH.value = count;
      cellH.font = cellStyle.font;
      cellH.fill = achievedcellstyle.fill;
      cellH.alignment = cellStyle.alignment;
      cellH.border = cellStyle.border;
    });


    
    const criteriaMapLucknow = {
      4: ['Lucknow', 'Mahindra Finance','Used Vehicle'],
      5: ['Lucknow', 'Tata Motors Finance','Used Vehicle'],
      6: ['Lucknow', 'Cholamandalam','Used Vehicle'],
      7: ['Lucknow', 'HDB','Used Vehicle'],
      8: ['Lucknow', 'IDFC First Bank','Used Vehicle'],
      9: ['Lucknow', 'IndusInd Bank','Used Vehicle'],
      10: ['Lucknow', 'AU Small Finance Bank','Used Vehicle'],
      11: ['Lucknow', 'Equitas Bank','Used Vehicle'],
      12: ['Lucknow', 'Tata OK','Used Vehicle'],
      13: ['Lucknow', 'Shriram Automall','Used Vehicle'],
      14: ['Lucknow',  'Multi Brand Outlet','Used Vehicle'],
      15: ['Lucknow', 'Mahindra','Used Vehicle'],
      16: ['Lucknow', 'TATA','Used Vehicle'],
      17: ['Lucknow',  'Maruti','Used Vehicle'],
      18: ['Lucknow',  'Ashok Leyland','Used Vehicle'],
      23: ['Lucknow',  'Mahindra','New Vehicle'],
      24: ['Lucknow',  'TATA','New Vehicle'],
      25: ['Lucknow',  'Maruti','New Vehicle'],
      26: ['Lucknow',  'Ashok Leyland','New Vehicle'],
      27: ['Lucknow',  'IDFC First Bank','New Vehicle'],
      28: ['Lucknow',  'IndusInd Bank','New Vehicle'],
   };

    // Helper function to check if a criterion is met
    const isCriterionMetLucknow = (answer, criterion) => {
      if (Array.isArray(criterion)) {
        return criterion.some(crit => Array.isArray(answer) ? answer.includes(crit) : answer === crit);
      } else {
        if (Array.isArray(answer)) {
          return answer.includes(criterion) || 
                 (criterion === 'Rs. 10-15 lakh per annum' && answer.includes('More than Rs. 15 lakh per annum')) ||
                 (criterion === 'Other' && answer.some(ans => ans.includes('Other:')));
        } else {
          return answer === criterion || 
                 (criterion === 'Rs. 10-15 lakh per annum' && answer === 'More than Rs. 15 lakh per annum') ||
                 (criterion === 'Other' && answer?.includes('Other:'));
        }
      }
    };



    // Count matches and fill values in "Achieved" column
    const countMatchesLucknow = (criteria) => {
      return dashboardData.filter(response =>
        criteria.every(criterion =>
          Array.isArray(criterion) ? criterion.some(subCriterion =>
            response.questions.some(q => isQuestionInCheckArray(q.question) && isCriterionMetLucknow(q.answer, subCriterion))
          ) :
            response.questions.some(q => isQuestionInCheckArray(q.question) && isCriterionMetLucknow(q.answer, criterion))
        )
      ).length;
    };

    // Iterate over criteria map and update worksheet
    Object.keys(criteriaMapLucknow).forEach(rowIndex => {
      const criteria = criteriaMapLucknow[rowIndex];
      const count = countMatchesLucknow(criteria);
      const cellH = worksheet.getCell(`W${rowIndex}`);
      cellH.value = count;
      cellH.font = cellStyle.font;
      cellH.fill = achievedcellstyle.fill;
      cellH.alignment = cellStyle.alignment;
      cellH.border = cellStyle.border;
    });

    
    // ------------------------Bengaluru---------------
    // Define criteria for "Achieved" columns
    const criteriaMapAhmedabad = {
      4: ['Ahmedabad', 'Mahindra Finance','Used Vehicle'],
      5: ['Ahmedabad', 'Tata Motors Finance','Used Vehicle'],
      6: ['Ahmedabad', 'Cholamandalam','Used Vehicle'],
      7: ['Ahmedabad', 'HDB','Used Vehicle'],
      8: ['Ahmedabad', 'IDFC First Bank','Used Vehicle'],
      9: ['Ahmedabad', 'IndusInd Bank','Used Vehicle'],
      10: ['Ahmedabad', 'AU Small Finance Bank','Used Vehicle'],
      11: ['Ahmedabad', 'Equitas Bank','Used Vehicle'],
      12: ['Ahmedabad', 'Tata OK','Used Vehicle'],
      13: ['Ahmedabad', 'Shriram Automall','Used Vehicle'],
      14: ['Ahmedabad',  'Multi Brand Outlet','Used Vehicle'],
      15: ['Ahmedabad', 'Mahindra','Used Vehicle'],
      16: ['Ahmedabad', 'TATA','Used Vehicle'],
      17: ['Ahmedabad',  'Maruti','Used Vehicle'],
      18: ['Ahmedabad',  'Ashok Leyland','Used Vehicle'],
      23: ['Ahmedabad',  'Mahindra','New Vehicle'],
      24: ['Ahmedabad',  'TATA','New Vehicle'],
      25: ['Ahmedabad',  'Maruti','New Vehicle'],
      26: ['Ahmedabad',  'Ashok Leyland','New Vehicle'],
      27: ['Ahmedabad',  'IDFC First Bank','New Vehicle'],
      28: ['Ahmedabad',  'IndusInd Bank','New Vehicle'],
   };

    // Helper function to check if a criterion is met
    const isCriterionMetAhmedabad = (answer, criterion) => {
      if (Array.isArray(criterion)) {
        return criterion.some(crit => Array.isArray(answer) ? answer.includes(crit) : answer === crit);
      } else {
       if (Array.isArray(answer)) {
          return answer.includes(criterion) || 
                 (criterion === 'Rs. 10-15 lakh per annum' && answer.includes('More than Rs. 15 lakh per annum')) ||
                 (criterion === 'Other' && answer.some(ans => ans.includes('Other:')));
        } else {
          return answer === criterion || 
                 (criterion === 'Rs. 10-15 lakh per annum' && answer === 'More than Rs. 15 lakh per annum') ||
                 (criterion === 'Other' && answer?.includes('Other:'));
        }
      }
    };

    // Count matches and fill values in "Achieved" column
    const countMatchesAhmedabad = (criteria) => {

      return dashboardData.filter(response =>
        criteria.every(criterion =>
          Array.isArray(criterion) ? criterion.some(subCriterion =>
            response.questions.some(q => isQuestionInCheckArray(q.question) && isCriterionMetAhmedabad(q.answer, subCriterion))
          ) :
            response.questions.some(q => isQuestionInCheckArray(q.question) && isCriterionMetAhmedabad(q.answer, criterion))
        )
      ).length;
    };

    Object.keys(criteriaMapAhmedabad).forEach(rowIndex => {
      const criteria = criteriaMapAhmedabad[rowIndex];
      const count = countMatchesAhmedabad(criteria);
      const cellH = worksheet.getCell(`Z${rowIndex}`);
      cellH.value = count;
      cellH.font = cellStyle.font;
      cellH.fill = achievedcellstyle.fill;
      cellH.alignment = cellStyle.alignment;
      cellH.border = cellStyle.border;
    });
  

    const criteriaMapNasik = {
      4: ['Nasik', 'Mahindra Finance','Used Vehicle'],
      5: ['Nasik', 'Tata Motors Finance','Used Vehicle'],
      6: ['Nasik', 'Cholamandalam','Used Vehicle'],
      7: ['Nasik', 'HDB','Used Vehicle'],
      8: ['Nasik', 'IDFC First Bank','Used Vehicle'],
      9: ['Nasik', 'IndusInd Bank','Used Vehicle'],
      10: ['Nasik', 'AU Small Finance Bank','Used Vehicle'],
      11: ['Nasik', 'Equitas Bank','Used Vehicle'],
      12: ['Nasik', 'Tata OK','Used Vehicle'],
      13: ['Nasik', 'Shriram Automall','Used Vehicle'],
      14: ['Nasik',  'Multi Brand Outlet','Used Vehicle'],
      15: ['Nasik', 'Mahindra','Used Vehicle'],
      16: ['Nasik', 'TATA','Used Vehicle'],
      17: ['Nasik',  'Maruti','Used Vehicle'],
      18: ['Nasik',  'Ashok Leyland','Used Vehicle'],
      23: ['Nasik',  'Mahindra','New Vehicle'],
      24: ['Nasik',  'TATA','New Vehicle'],
      25: ['Nasik',  'Maruti','New Vehicle'],
      26: ['Nasik',  'Ashok Leyland','New Vehicle'],
      27: ['Nasik',  'IDFC First Bank','New Vehicle'],
      28: ['Nasik',  'IndusInd Bank','New Vehicle'],
      };

    // Helper function to check if a criterion is met
    const isCriterionMetNasik = (answer, criterion) => {
      if (Array.isArray(criterion)) {
        return criterion.some(crit => Array.isArray(answer) ? answer.includes(crit) : answer === crit);
      } else {
       if (Array.isArray(answer)) {
          return answer.includes(criterion) || 
                 (criterion === 'Rs. 10-15 lakh per annum' && answer.includes('More than Rs. 15 lakh per annum')) ||
                 (criterion === 'Other' && answer.some(ans => ans.includes('Other:')));
        } else {
          return answer === criterion || 
                 (criterion === 'Rs. 10-15 lakh per annum' && answer === 'More than Rs. 15 lakh per annum') ||
                 (criterion === 'Other' && answer?.includes('Other:'));
        }
      }
    };

    // Count matches and fill values in "Achieved" column
    const countMatchesNasik = (criteria) => {

      return dashboardData.filter(response =>
        criteria.every(criterion =>
          Array.isArray(criterion) ? criterion.some(subCriterion =>
            response.questions.some(q => isQuestionInCheckArray(q.question) && isCriterionMetNasik(q.answer, subCriterion))
          ) :
            response.questions.some(q => isQuestionInCheckArray(q.question) && isCriterionMetNasik(q.answer, criterion))
        )
      ).length;
    };

    Object.keys(criteriaMapNasik).forEach(rowIndex => {
      const criteria = criteriaMapNasik[rowIndex];
      const count = countMatchesNasik(criteria);
      const cellH = worksheet.getCell(`AC${rowIndex}`);
      cellH.value = count;
      cellH.font = cellStyle.font;
      cellH.fill = achievedcellstyle.fill;
      cellH.alignment = cellStyle.alignment;
      cellH.border = cellStyle.border;
    });

    
    const criteriaMapCochin = {
      4: ['Cochin', 'Mahindra Finance','Used Vehicle'],
      5: ['Cochin', 'Tata Motors Finance','Used Vehicle'],
      6: ['Cochin', 'Cholamandalam','Used Vehicle'],
      7: ['Cochin', 'HDB','Used Vehicle'],
      8: ['Cochin', 'IDFC First Bank','Used Vehicle'],
      9: ['Cochin', 'IndusInd Bank','Used Vehicle'],
      10: ['Cochin', 'AU Small Finance Bank','Used Vehicle'],
      11: ['Cochin', 'Equitas Bank','Used Vehicle'],
      12: ['Cochin', 'Tata OK','Used Vehicle'],
      13: ['Cochin', 'Shriram Automall','Used Vehicle'],
      14: ['Cochin',  'Multi Brand Outlet','Used Vehicle'],
      15: ['Cochin', 'Mahindra','Used Vehicle'],
      16: ['Cochin', 'TATA','Used Vehicle'],
      17: ['Cochin',  'Maruti','Used Vehicle'],
      18: ['Cochin',  'Ashok Leyland','Used Vehicle'],
      23: ['Cochin',  'Mahindra','New Vehicle'],
      24: ['Cochin',  'TATA','New Vehicle'],
      25: ['Cochin',  'Maruti','New Vehicle'],
      26: ['Cochin',  'Ashok Leyland','New Vehicle'],
      27: ['Cochin',  'IDFC First Bank','New Vehicle'],
      28: ['Cochin',  'IndusInd Bank','New Vehicle'],
  };

    // Helper function to check if a criterion is met
    const isCriterionMetCochin = (answer, criterion) => {
      if (Array.isArray(criterion)) {
        return criterion.some(crit => Array.isArray(answer) ? answer.includes(crit) : answer === crit);
      } else {
       if (Array.isArray(answer)) {
          return answer.includes(criterion) || 
                 (criterion === 'Rs. 10-15 lakh per annum' && answer.includes('More than Rs. 15 lakh per annum')) ||
                 (criterion === 'Other' && answer.some(ans => ans.includes('Other:')));
        } else {
          return answer === criterion || 
                 (criterion === 'Rs. 10-15 lakh per annum' && answer === 'More than Rs. 15 lakh per annum') ||
                 (criterion === 'Other' && answer?.includes('Other:'));
        }
      }
    };

    // Count matches and fill values in "Achieved" column
    const countMatchesCochin = (criteria) => {

      return dashboardData.filter(response =>
        criteria.every(criterion =>
          Array.isArray(criterion) ? criterion.some(subCriterion =>
            response.questions.some(q => isQuestionInCheckArray(q.question) && isCriterionMetCochin(q.answer, subCriterion))
          ) :
            response.questions.some(q => isQuestionInCheckArray(q.question) && isCriterionMetCochin(q.answer, criterion))
        )
      ).length;
    };

    Object.keys(criteriaMapCochin).forEach(rowIndex => {
      const criteria = criteriaMapCochin[rowIndex];
      const count = countMatchesCochin(criteria);
      const cellH = worksheet.getCell(`AF${rowIndex}`);
      cellH.value = count;
      cellH.font = cellStyle.font;
      cellH.fill = achievedcellstyle.fill;
      cellH.alignment = cellStyle.alignment;
      cellH.border = cellStyle.border;
    });


    // ------------------------Coimbatore---------------
    // Define criteria for "Achieved" columns
    const criteriaMapRachi = {
      4: ['Ranchi', 'Mahindra Finance','Used Vehicle'],
      5: ['Ranchi', 'Tata Motors Finance','Used Vehicle'],
      6: ['Ranchi', 'Cholamandalam','Used Vehicle'],
      7: ['Ranchi', 'HDB','Used Vehicle'],
      8: ['Ranchi', 'IDFC First Bank','Used Vehicle'],
      9: ['Ranchi', 'IndusInd Bank','Used Vehicle'],
      10: ['Ranchi', 'AU Small Finance Bank','Used Vehicle'],
      11: ['Ranchi', 'Equitas Bank','Used Vehicle'],
      12: ['Ranchi', 'Tata OK','Used Vehicle'],
      13: ['Ranchi', 'Shriram Automall','Used Vehicle'],
      14: ['Ranchi',  'Multi Brand Outlet','Used Vehicle'],
      15: ['Ranchi', 'Mahindra','Used Vehicle'],
      16: ['Ranchi', 'TATA','Used Vehicle'],
      17: ['Ranchi',  'Maruti','Used Vehicle'],
      18: ['Ranchi',  'Ashok Leyland','Used Vehicle'],
      23: ['Ranchi',  'Mahindra','New Vehicle'],
      24: ['Ranchi',  'TATA','New Vehicle'],
      25: ['Ranchi',  'Maruti','New Vehicle'],
      26: ['Ranchi',  'Ashok Leyland','New Vehicle'],
      27: ['Ranchi',  'IDFC First Bank','New Vehicle'],
      28: ['Ranchi',  'IndusInd Bank','New Vehicle'],
   };

    // Helper function to check if a criterion is met
    const isCriterionMetRachi = (answer, criterion) => {
      if (Array.isArray(criterion)) {
        return criterion.some(crit => Array.isArray(answer) ? answer.includes(crit) : answer === crit);
      } else {
       if (Array.isArray(answer)) {
          return answer.includes(criterion) || 
                 (criterion === 'Rs. 10-15 lakh per annum' && answer.includes('More than Rs. 15 lakh per annum')) ||
                 (criterion === 'Other' && answer.some(ans => ans.includes('Other:')));
        } else {
          return answer === criterion || 
                 (criterion === 'Rs. 10-15 lakh per annum' && answer === 'More than Rs. 15 lakh per annum') ||
                 (criterion === 'Other' && answer?.includes('Other:'));
        }
      }
    };

    // Count matches and fill values in "Achieved" column
    const countMatchesRachi = (criteria) => {

      return dashboardData.filter(response =>
        criteria.every(criterion =>
          Array.isArray(criterion) ? criterion.some(subCriterion =>
            response.questions.some(q => isQuestionInCheckArray(q.question) && isCriterionMetRachi(q.answer, subCriterion))
          ) :
            response.questions.some(q => isQuestionInCheckArray(q.question) && isCriterionMetRachi(q.answer, criterion))
        )
      ).length;
    };

    Object.keys(criteriaMapRachi).forEach(rowIndex => {
      const criteria = criteriaMapRachi[rowIndex];
      const count = countMatchesRachi(criteria);
      const cellH = worksheet.getCell(`AI${rowIndex}`);
      cellH.value = count;
      cellH.font = cellStyle.font;
      cellH.fill = achievedcellstyle.fill;
      cellH.alignment = cellStyle.alignment;
      cellH.border = cellStyle.border;
    });


// ----------------------------------------------------------------------------------Achieved Finished----------------------
for (let rowIndex = 4; rowIndex <= 18; rowIndex++) {
  const cellC = worksheet.getCell(`B${rowIndex}`);
  if (cellC.value) {
    const sum = ['H','K','N','Q','T','W','Z','AC','AF','AI']
      .map(col => worksheet.getCell(`${col}${rowIndex}`).value || 0)
      .reduce((acc, value) => acc + value, 0);

    const cellE = worksheet.getCell(`E${rowIndex}`);
    cellE.value = sum;

      cellE.font = cellStyle.font;

      cellE.fill = achievedcellstyle.fill;
    

    cellE.alignment = cellStyle.alignment;
    cellE.border = cellStyle.border;
  }
}
for (let rowIndex = 23; rowIndex <= 28; rowIndex++) {
  const cellC = worksheet.getCell(`B${rowIndex}`);
  if (cellC.value) {
    const sum = ['H','K','N','Q','T','W','Z','AC','AF','AI']
      .map(col => worksheet.getCell(`${col}${rowIndex}`).value || 0)
      .reduce((acc, value) => acc + value, 0);

    const cellE = worksheet.getCell(`E${rowIndex}`);
    cellE.value = sum;

      cellE.font = cellStyle.font;

      cellE.fill = achievedcellstyle.fill;
    

    cellE.alignment = cellStyle.alignment;
    cellE.border = cellStyle.border;
  }
}
// ---------------------------------------------------------------------------------------------

const cellsArray = ['E','H','K','N','Q','T','W','Z','AC','AF','AI']; 
const startRow = 4
const endRow = 18
const targetRow =19
  cellsArray.forEach(cellColumn => {
    // Calculate the sum for the current cell column
    const sum = Array.from({ length: endRow - startRow + 1 }, (_, index) => {
      const rowIndex = startRow + index;
      const cellValue = worksheet.getCell(`${cellColumn}${rowIndex}`).value || 0;
      return Number(cellValue);
    }).reduce((acc, value) => acc + value, 0);

    // Set the sum in the target row for the current column
    const targetCell = worksheet.getCell(`${cellColumn}${targetRow}`);
    targetCell.value = sum;
       
          targetCell.font = headerStyle.font
          targetCell.fill = achievedstyle.fill;
          targetCell.alignment = headerStyle.alignment;
          targetCell.border=headerStyle.border;
       
  });


  const cellsArraynew = ['E','H','K','N','Q','T','W','Z','AC','AF','AI']; 
const startRownew = 23
const endRownew = 28
const targetRownew =29
cellsArraynew.forEach(cellColumn => {
    // Calculate the sum for the current cell column
    const sum = Array.from({ length: endRownew - startRownew + 1 }, (_, index) => {
      const rowIndex = startRownew + index;
      const cellValue = worksheet.getCell(`${cellColumn}${rowIndex}`).value || 0;
      return Number(cellValue);
    }).reduce((acc, value) => acc + value, 0);

    // Set the sum in the target row for the current column
    const targetCell = worksheet.getCell(`${cellColumn}${targetRownew}`);
    targetCell.value = sum;
       
          targetCell.font = headerStyle.font
          targetCell.fill = achievedstyle.fill;
          targetCell.alignment = headerStyle.alignment;
          targetCell.border=headerStyle.border;
       
  });
// ---------------------------------------------------------------------
 //  Sum the values of the specified columns for each row and fill in column E
 

 const columnsFinal = [
  { result: 'F', from: 'D', subtract: 'E' },
  { result: 'I', from: 'G', subtract: 'H' },
  { result: 'L', from: 'J', subtract: 'K' },
  { result: 'O', from: 'M', subtract: 'N' },
  { result: 'R', from: 'P', subtract: 'Q' },
  { result: 'U', from: 'S', subtract: 'T' },
  { result: 'X', from: 'V', subtract: 'W' },
  { result: 'AA', from: 'Y', subtract: 'Z' },
  { result: 'AD', from: 'AB', subtract: 'AC' },
  { result: 'AG', from: 'AE', subtract: 'AF' },
  { result: 'AJ', from: 'AH', subtract: 'AI' },
];

columnsFinal.forEach(({ result, from, subtract }) => {
  for (let rowIndex = 4; rowIndex <= 19; rowIndex++) {
    const cellC = worksheet.getCell(`B${rowIndex}`);
    if (cellC.value) {
      const cellFrom = worksheet.getCell(`${from}${rowIndex}`);
      const cellSubtract = worksheet.getCell(`${subtract}${rowIndex}`);
      const cellToFill = worksheet.getCell(`${result}${rowIndex}`);
      const valueFrom = cellFrom.value || 0;
      const valueSubtract = cellSubtract.value || 0;

      // Calculate the result and set the value
      const calculatedValue = valueFrom - valueSubtract;
      cellToFill.value = calculatedValue ;

      // Apply styles
      if (rowIndex == 19) {
        cellToFill.font = headerStyle.font;
        cellToFill.fill = pendingtyle.fill;
      } else {
        cellToFill.font = cellStyle.font;
        cellToFill.fill = pendingcellstyle.fill;
      }
      cellToFill.alignment = cellStyle.alignment;
      cellToFill.border = cellStyle.border;
    }
  }
});

columnsFinal.forEach(({ result, from, subtract }) => {
  for (let rowIndex = 23; rowIndex <= 29; rowIndex++) {
    const cellC = worksheet.getCell(`B${rowIndex}`);
    if (cellC.value) {
      const cellFrom = worksheet.getCell(`${from}${rowIndex}`);
      const cellSubtract = worksheet.getCell(`${subtract}${rowIndex}`);
      const cellToFill = worksheet.getCell(`${result}${rowIndex}`);
      const valueFrom = cellFrom.value || 0;
      const valueSubtract = cellSubtract.value || 0;

      // Calculate the result and set the value
      const calculatedValue = valueFrom - valueSubtract;
      cellToFill.value = calculatedValue ; 

      // Apply styles
      if (rowIndex == 19 || rowIndex == 29) {
        cellToFill.font = headerStyle.font;
        cellToFill.fill = pendingtyle.fill;
      } else {
        cellToFill.font = cellStyle.font;
        cellToFill.fill = pendingcellstyle.fill;
      }
      cellToFill.alignment = cellStyle.alignment;
      cellToFill.border = cellStyle.border;
    }
  }
});

const cellsArraygrandtotal = [
  'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 
  'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'AA', 'AB', 'AC', 'AD', 
  'AE', 'AF', 'AG', 'AH', 'AI', 'AJ'
];

const sourceRows = [19, 29]; // Rows to sum values from
const targetRowgrandtotal = 31; // Row to store the result

cellsArraygrandtotal.forEach(cellColumn => {
  // Calculate the sum for the specific rows in the current column
  const sum = sourceRows
    .map(row => worksheet.getCell(`${cellColumn}${row}`).value || 0)
    .reduce((acc, value) => acc + Number(value), 0);

  // Set the calculated sum in the target row for the current column
  const targetCell = worksheet.getCell(`${cellColumn}${targetRowgrandtotal}`);
  targetCell.value = sum;

  // Apply styles to the target cell
  targetCell.font = headerStyle.font;
  targetCell.fill = cellStyle.fill;
  targetCell.alignment = headerStyle.alignment;
  targetCell.border = headerStyle.border;
});


    
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/octet-stream' });
      saveAs(blob, 'LMVQCC.xlsx');
      setLoader(false);


  };

  return (
    <>
      {loader && <Loader />}
      <div className="excelcontainer">
        <div className="excelcard">
        
            <> <label>LMV Survey</label>
              <button className="btn btn-primary" onClick={() => handleDownload()}>Download</button></>
          <br />
         
         
        </div>

      </div>
    </>
  );
};

export default LmvExcelReport;

